<template>
<header class="content">
  
  <div class="pure-g logo-wrap">
    <div class="pure-u-6-24 logo-side"><div class="logoline"></div></div>
    <div class="pure-u-12-24" id="logo"></div>
    <div class="pure-u-6-24 logo-side"><div class="logoline"></div></div>
  </div>

  <h1 id="subject">
    <span class="bg" v-if="this.sharedState.pledgeCompleted">
      Looking forward to seeing you run<label v-show="this.sharedState.newUser.name">, {{ this.sharedState.newUser.name | firstName }}</label>!
    </span>
    <span class="bg" v-else>
      Pledge to run at least 30 minutes a month
    </span>
  </h1>

<!--
<pre style="color:white;">NEW USER: {{ this.sharedState.newUser }}</pre>
<pre style="color:white;">HASH USER: {{ this.sharedState.referralUser }}</pre>
-->

</header>
</template>

<script>
import Vue from 'vue'
//import store from './store'

// Needed for Geolocation
var https = require('https')
//console.log(store);
//console.log(store.state.itemsPerPage)

//console.log(app);

//var Vue = require('vue')
var firebase = require('firebase')
var timestampRef = firebase.database().ref('timestamp')

/*components: { App },*/

export default {
//var headerComponent = new Vue({
  name: 'logo-header',
//  store,
  data() {
    return {
      sharedState : this.$store.state,
      tabActive : true
    }
  },

  filters: {
    firstName (fullName) {
      var spaceLocation = fullName.indexOf(" ");
      
      if(spaceLocation && spaceLocation > 1){
        return fullName.substring(0, spaceLocation)
      }
      
      return fullName;
    }
  },

  // computed property for form validation state
  computed: {
  },
  // methods
  methods: {

    
  },

  mounted () {

    var parent = this;

    window.onfocus = function () { 
      parent.tabActive = true; 
    }; 

    window.onblur = function () { 
      parent.tabActive = false; 
    };

    setInterval(function () {

      if(parent.tabActive){
        timestampRef.transaction(function(lastTimestamp) {
          // Keep session alive
          var timestamp = Date.now() / 1000 | 0;

          if(isFinite(timestamp) && timestamp > 0 && timestamp > lastTimestamp){
            return timestamp;
          }
        });
      }//end of active tab

    }, 30000);


    var options = {    
        host: 'ip.nf',    
        path: '/me.json',
        method: 'GET'
    };
    /*
    var options = {
        host: 'geoip.nekudo.com',
        path: '/api/',
        method: 'GET'
    };
    */

    var req = https.request(options, function(res) {    
        //console.log('STATUS: ' + res.statusCode);

        if(res.statusCode == "200"){
          // We've got a response

          res.setEncoding('utf8');    
          
          res.on('data', function (locationString) {

            var location = JSON.parse(locationString)

            if(location.ip.city){
             parent.sharedState.newUser.location.city = location.ip.city; 
            }

            if(location.ip.country){
             parent.sharedState.newUser.location.country = location.ip.country; 
            }

            if(location.ip.country_code){
             parent.sharedState.newUser.location.code = location.ip.country_code; 
            }

          });

        }

    });

    // write data to request body
    /*
    req.write('data\n');
    req.write('data\n');
    req.end();
    */
    req.end();

  }
}

</script>

<style>
   
  header .logo-wrap{
    height: 14em;
    padding-top: 1em;
  }

  header #logo{
    background: url(../assets/running-year-logo.png) no-repeat center center;
    background-size: contain;
    image-rendering: pixelated;/* Sharper logo */
    height: 100%;
    width: 46%;
    margin: 0 2%;
  }

  header .logo-side{
    /* Needed for Safari */
    height: 100%;
  }

  header .logoline{
    height: 5px;
    position: relative;
    top: 48%;
    
    -ms-transform: translateY(-48%);
    -webkit-transform: translateY(-48%);
    -moz-transform: translateY(-48%);
    -o-transform: translateY(-48%);

    transform: translateY(-48%);
    background: rgba(255,255,255,0.5);
    border-radius: 10px;
    margin: 0 1em;
  }

  header h1{
    color:#333;
    font-weight: 400;
    font-size: 3.0em;
    margin-top: 1em;
    text-align: center;
    letter-spacing: 1px;
    line-height: 1.8em;
  }

  header .bg{
    padding:0.1em 0.4em;
    background: rgba(255,255, 255, 0.7);
  }

  @media only screen and (max-width: 48em) {
      /* Small screen styles */

      header h1{
        font-size: 2.5em;
        margin-top: .4em;
        padding: 0 .2em;
      }

      header h2{
        font-size: 1.5em;
        line-height: 2em;
        padding: 0 .5em;
      }
  }

  @media only screen and (max-width: 64em) {
  /* Medium screen styles */
    header .logo-side{
      width:20%;
    }

    header #logo{
      width:56%;
    }
  }

  @media only screen and (max-width: 48em) {
  /* Small screen styles */
    header .logo-side{
      width:10%;
    }

    header #logo{
      width: 76%;
    }
  }

  @media only screen and (max-width: 30em) {
  /* Mobile screen styles */

    header h1{
      font-size: 2em;
      margin-top: 0;
    }

    header .logo-side{
      width:5%;
    }

    #logo{
      width:90%;
    }
  }

</style>



// WEBPACK FOOTER //
// Header.vue?51b3ec7a